import { Injectable } from '@angular/core';

import { environment } from '@env/environment';

import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { HttpBaseResponse } from '@app/one-core/common/http/http-base-response';
import { OneHttpClient } from '@app/one-core/common/http/one-httpclient-factory';

import { ArticleOverviewSection } from '@app/one-models/models/article-overview-section';
import { ArticleOverviewSectionType } from '@app/one-models/models/article-overview-section-type';
import { TenantSettings } from '@app/one-models/models/tenant-settings';
import { UserTenant } from '@app/one-models/models/user-tenant';

@Injectable({
  providedIn: 'root'
})
export class PortalSettingService {
  private api = environment.services.portalApi;
  private configurationSectionEndpoint = '/settings/sections';
  private tenantEndpoint = '/tenant';

  private sectionsOrder$: Observable<ArticleOverviewSection[]>;

  constructor(
    private http: OneHttpClient) { }

  getSectionsOrder(): Observable<ArticleOverviewSection[]> {
    if (!this.sectionsOrder$) {
      const url = `${this.api}${this.configurationSectionEndpoint}`;
      this.sectionsOrder$ = this.http.get<HttpBaseResponse<ArticleOverviewSection[]>>(url).pipe(
        map((response) => {
          // TODO: Remove this manual section insertion when the backend properly includes customLinkageTargets in the configuration response

          const result = response.data;

          const acesSection = result.find((section) =>
            section.sectionId === ArticleOverviewSectionType.aceLinkageTargets
          );

          if (acesSection) {
            const acesSequentialId = acesSection.sequentialId;

            result.forEach((section) => {
              if (section.sequentialId > acesSequentialId) {
                section.sequentialId += 1;
              }
            });

            result.push({
              sectionId: ArticleOverviewSectionType.customLinkageTargets,
              sequentialId: acesSequentialId + 1,
              positionId: 2,
              visibleAlways: true,
              allArticleGroups: true,
              visibleArticleGroupIds: [],
            });
          }

        return result;
        }),
        shareReplay(1)
      );
    }

    return this.sectionsOrder$;
  }

  getSectionsOrderForMaintenance(): Observable<ArticleOverviewSection[]> {
    const url = `${this.api}${this.configurationSectionEndpoint}/maintenance`;
    return this.http.get<HttpBaseResponse<ArticleOverviewSection[]>>(url).pipe(
      map(response => response.data));
  }

  saveSectionsOrder(sectionsOrder: ArticleOverviewSection[]): Observable<HttpBaseResponse<ArticleOverviewSection[]>> {
    const url = `${this.api}${this.configurationSectionEndpoint}/maintenance`;
    return this.http.put<HttpBaseResponse<ArticleOverviewSection[]>>(url, sectionsOrder).pipe(
      map(response => {
        this.sectionsOrder$ = null;
        return response;
      }),
    );
  }

  getTenantSettings(): Observable<TenantSettings> {
    const url = `${this.api}${this.tenantEndpoint}/settings`;
    return this.http.get<HttpBaseResponse<TenantSettings>>(url).pipe(
      map(response => response.data),
      shareReplay(1),
    );
  }

  getTenants(): Observable<UserTenant[]> {
    const url = `${this.api}/user/tenants`;
    return this.http.get<HttpBaseResponse<UserTenant[]>>(url).pipe(
      map(response => response.data),
      shareReplay(1),
    );
  }
}
